import youtubeVideos from '../data/youtubeVideos.json';

export default class YouTubeService {
    static getData(id) {
        return youtubeVideos.youtube_videos[id];
    }
}